export default __webpack_public_path__ + "static/media/cubeWithiLight.ce9fe4aa.png";